/* eslint-disable react-hooks/exhaustive-deps */
import { useTooltip } from "context/TooltipProvider";
import React, { useEffect, useState } from "react";
import {
  addCaseRelation,
  fetchCaseCreationByCRNumberAndIncidentRegNo,
} from "services/caseServices";
import { CaseCreation, InvestigationFile } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandler, errorHandlerOnForm } from "utils/helper";

interface Props {
  file: InvestigationFile;
  onCancel: () => void;
}

const MergeCases: React.FC<Props> = ({ file, onCancel }) => {
  const { showTooltip } = useTooltip();
  const [loading, setLoading] = React.useState(false);

  const [formState, setFormState] = useState<{
    relation_type: "merged_from" | "split_from";
    from_case: number;
    to_case: number;
  }>({
    relation_type: "merged_from",
    from_case: 0,
    to_case: 0,
  });
  const [cases, setCases] = useState<CaseCreation[]>([]);

  const fetchData = () => {
    setLoading(true);
    fetchCaseCreationByCRNumberAndIncidentRegNo(
      file?.crime_reference_number ?? "",
      file?.incident_registration_number ?? ""
    )
      .then((data) => {
        setCases(data);
        setLoading(false);
      })
      .catch((error) => {
        showTooltip(errorHandler(error));
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!formState.from_case) return "From Case is Required.";
    else if (!formState.to_case) return "To Case is Required.";
    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }

    setLoading(true);
    addCaseRelation(formState)
      .then(() => {
        showTooltip("Successfully Submitted!", "success");
        onCancel();
      })
      .catch((err) => {
        showTooltip(errorHandlerOnForm(err?.response?.data), "error");
      });
  };

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onCancel();
    }
  };

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-[600px]">
        <h2 className="text-lg font-semibold text-gray-800">Merge Cases</h2>
        <form onSubmit={handleSubmit}>
          <div className="rounded-lg  mt-4 ">
            {/* Suspect Information */}
            <div>
              <div>
                <div className="rounded-lg  mt-4 ">
                  Are you sure you want to merge case ?
                </div>
                {/* Select Suspect (first) */}
                <div className="flex flex-col mt-4 ">
                  <label className="text-sm text-[#747171] font-[inter] font-[400] flex-col-2 mb-2">
                    Select From Case
                  </label>
                  <select
                    className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                    value={formState?.from_case ?? ""}
                    name="from_case"
                    onChange={handleChange}
                  >
                    <option value={""}>Select From Case</option>
                    {cases.map((caseItem, index) => (
                      <option key={index} value={caseItem?.id}>
                        Prosecutor Reg No.{" "}
                        {caseItem?.prosecutor_registration_number}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col mt-4 ">
                  <label className="text-sm text-[#747171] font-[inter] font-[400] flex-col-2 mb-2">
                    Select To Case
                  </label>
                  <select
                    className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                    value={formState?.to_case ?? ""}
                    name="to_case"
                    onChange={handleChange}
                  >
                    <option value={""}>Select To Case</option>
                    {cases
                      ?.filter(
                        (caseItem) => caseItem?.id !== formState?.from_case
                      )
                      .map((caseItem, index) => (
                        <option key={index} value={caseItem?.id}>
                          Prosecutor Reg No.{" "}
                          {caseItem?.prosecutor_registration_number}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 flex justify-between gap-2">
            <button
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded w-full hover:bg-gray-300"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`border border-[#E90101] bg-[#E90101] px-10 py-2 text-white 
                              font-[Poppins] cursor-pointer font-[500] w-full
                              text-base rounded-md hover:bg-white hover:text-[#E90101]
                              ${
                                loading ? "opacity-50 cursor-not-allowed" : ""
                              }`}
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  {LoadingIcon}
                  Loading...
                </div>
              ) : (
                "Merge"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MergeCases;
